module.exports = __webpack_public_path__ + "static/img/4.228154ec.jpg";